// removed by extract-text-webpack-plugin
module.exports = {"User":"User__User___JuDy7","Avatar":"User__Avatar___1FkwO","WithClient":"User__WithClient___1aqJZ","UserDropdownWrap":"User__UserDropdownWrap___3Fpx7","Dropdown":"User__Dropdown___xzS1W","UserStatus":"User__UserStatus___2EChL","DropdownText":"User__DropdownText___eK_eF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/User/User.scss
// module id = 1433
// module chunks = 0